import styled from '@emotion/styled';
import { Section } from '../../content-sections/ui/components/Section';
import { StyledCardsContainer } from '../../../components/common/cards/CardsContainer';
import PoiCard from './PoiCard';
import { ShopDineRelaxPagination } from './ShopDineRelaxPagination';
import { Css, Responsive } from '../../../ui';
import { AirportCodes } from '../../../types/airports';
import { IPoiItem } from '../domain/models/IPoiItem';

interface IPoiListProps {
	slicedPoiData: IPoiItem[];
	totalPages: number;
	currentPageIndex: number;
	setCurrentPageIndex: (currentPageIndex: number) => void;
	airportCode: AirportCodes;
}

export default function PoiList({
	slicedPoiData,
	totalPages,
	currentPageIndex,
	setCurrentPageIndex,
	airportCode,
}: IPoiListProps) {
	return (
		<PoiSection>
			<PoiContainer>
				{slicedPoiData.map((poi) => (
					<PoiCard key={poi.poiId} airportCode={airportCode} poi={poi} />
				))}
			</PoiContainer>
			<ShopDineRelaxPagination
				currentPageIndex={currentPageIndex}
				totalPages={totalPages}
				onPageChange={(newPageIndex) => setCurrentPageIndex(newPageIndex)}
			/>
		</PoiSection>
	);
}

export const PoiSection = styled(Section)`
	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		margin: 0;
	}
`;

export const PoiContainer = styled(StyledCardsContainer)`
	grid-template-columns: repeat(4, 1fr);

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		grid-template-columns: repeat(1, 1fr);
		gap: ${Css.pxToRem(16)};
	}

	li {
		padding-left: 0;
		border: unset;
	}
`;
